@use "ui/styles/breakpoints";
@use "ui/styles/fonts";
@use "ui/styles/sizes";

.checkboxCell {
  display: flex;
  align-items: center;
  justify-content: center;
}

.disabledRow {
  cursor: not-allowed;
  opacity: 0.5;
}

.planNameCell {
  display: flex;
  align-items: center;
  padding: sizes.$s4;
  font-size: fonts.$base;
  gap: sizes.$s4;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  .planImage {
    display: flex;
    justify-content: center;
    align-items: center;
    @include breakpoints.mobile {
      max-width: unset;
      margin-right: 0;
    }

    > img {
      height: sizes.$s9;
      width: sizes.$s12;
      object-fit: contain;
    }
  }
}
